export const profilingChoices = [
  {
    id: 'conformity',
    choice: 'onboarding.profilingView.choices.configSecurity',
  },
  {
    id: 'filestorage',
    choice: 'onboarding.profilingView.choices.fileStorage',
  },
  {
    id: 'network',
    choice: 'onboarding.profilingView.choices.networks',
  },
  {
    id: 'snyk',
    choice: 'onboarding.profilingView.choices.sourceCode',
  },
  {
    id: 'workload',
    choice: 'onboarding.profilingView.choices.endpointsAndWorkloads',
  },
  {
    id: 'container',
    choice: 'onboarding.profilingView.choices.containers',
  },
];

export const services = [
  {
    id: 'conformity',
    title: 'onboarding.confirmationView.services.conformity.title',
    message: 'onboarding.confirmationView.services.conformity.message',
  },
  {
    id: 'filestorage',
    title: 'onboarding.confirmationView.services.fss.title',
    message: 'onboarding.confirmationView.services.fss.message',
  },
  {
    id: 'network',
    title: 'onboarding.confirmationView.services.network.title',
    message: 'onboarding.confirmationView.services.network.message',
  },
  {
    id: 'snyk',
    title: 'onboarding.confirmationView.services.snyk.title',
    message: 'onboarding.confirmationView.services.snyk.message',
  },
  {
    id: 'workload',
    title: 'onboarding.confirmationView.services.workload.title',
    message: 'onboarding.confirmationView.services.workload.message',
  },
  {
    id: 'container',
    title: 'onboarding.confirmationView.services.container.title',
    message: 'onboarding.confirmationView.services.container.message',
  },
];
